export { default } from "./useListSalesExecutives";
export type { HookArgs } from "./useListSalesExecutives";
